import React from "react";
import HamburgerButton from "./HamburgerButton";
import Menu from "../Menu";
import { fonts } from "..";
import { css } from "@linaria/core";

interface HamburgerMenuProps {
  children: React.ReactNode;
}

const HamburgerMenu = ({ children }: HamburgerMenuProps) => {
  const [hamburgerOpened, setHamburgerOpen] = React.useState(false);

  return (
    <Menu
      data-cy="hamburger-menu-list"
      overlay={children}
      opened={hamburgerOpened}
      arrowWidth={0}
      //   gap={12}
      setOpened={setHamburgerOpen}
      placement="bottom"
      className={hamburgerMenu}
    >
      <HamburgerButton active={hamburgerOpened} />
    </Menu>
  );
};
export default HamburgerMenu;

const hamburgerMenu = css`
  min-width: 200px;
  font: ${fonts.body2};
  overflow: clip;
`;
